import { render, staticRenderFns } from "./EditarEmpleadoDeParteDiario.vue?vue&type=template&id=2713fe50&"
import script from "./EditarEmpleadoDeParteDiario.vue?vue&type=script&lang=js&"
export * from "./EditarEmpleadoDeParteDiario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports